import { t } from '@dna/utils'

class DNABreadcrumb extends HTMLElement {
  connectedCallback() {
    const $breadcrumb = document.getElementById('breadcrumb')
    const $firstAnchor = $breadcrumb?.querySelector('li:first-child')
    const storePage = document.querySelector('.js-breadcrumb-store')
    const standardPage = document.querySelector('.js-breadcrumb-standard')
    let referrerUrl = document.referrer
    const referrerSession = sessionStorage.getItem('referrer')
    if (!referrerUrl && referrerSession) {
      referrerUrl = referrerSession
      sessionStorage.removeItem('referrer')
    }
    const breadcrumbText = t('general.breadcrumb.back_button_text')

    if (
      window.history.length > 1 &&
      referrerUrl &&
      this.isSameDomain(referrerUrl) &&
      !storePage &&
      !standardPage
    ) {
      const $backLink = document.createElement('a')
      $backLink.href = 'javascript:history.back()'
      $backLink.textContent = `< ${breadcrumbText}`
      $backLink.classList.add('breadcrumb__item')

      const $separator = document.createElement('span')
      $separator.textContent = '|'
      $separator.classList.add('breadcrumb__divider')
      $separator.setAttribute('aria-hidden', 'true')

      $breadcrumb?.insertBefore($backLink, $firstAnchor)
      $breadcrumb?.insertBefore($separator, $backLink.nextSibling)
    } else if (storePage) {
      const $storeLink = document.querySelector('.js-breadcrumb-item-store')
      const rootUrl = window.Shopify.routes.root
      $storeLink.href = `${rootUrl}pages/stores`
      $storeLink.setAttribute(
        'itemid',
        `${window.location.protocol}//${window.Shopify.shop}${rootUrl}pages/stores`,
      )
    }

    if ($breadcrumb) {
      const lineHeight = Number.parseFloat(
        window.getComputedStyle($breadcrumb).lineHeight,
      )
      const breadcrumbHeight = $breadcrumb.clientHeight
      const numLines = breadcrumbHeight / lineHeight
      if (numLines > 1) {
        $firstAnchor.classList.add('ellipses')
      }
    }
  }

  isSameDomain(url) {
    if (!url) {
      return false
    }
    const currentDomain = window.location.origin
    const urlDomain = new URL(url).origin
    return currentDomain === urlDomain
  }
}
customElements.define('dna-breadcrumb', DNABreadcrumb)
